
// document.addEventListener('page:loaded', function() {
window.addEventListener('load', (event) => {
    // Globals..

    // ***********************************************
    // When subtotal in cart drawer changes
    // ***********************************************

    var target = Array.from(document.querySelectorAll('[data-subtotal]')).pop();
    var observer = new MutationObserver( updateSubtotal );
    observer.observe(target, { characterData: false, attributes: false, childList: true, subtree: false });

    function updateSubtotal(mutations) {
        console.log("Subtotal changed..");
        var cartSubtotal = document.querySelectorAll('[data-cart-subtotal]')[0];
        var subtotal = cartSubtotal.dataset.cartSubtotal;
        updateFreeShippingBar(subtotal);
    }

    function updateFreeShippingBar(subtotal) {
        var freeShippingBar = document.querySelectorAll('.free-shipping-bar')[0];
        var freeShippingAmount = freeShippingBar.dataset.freeShippingAmount;
        var free_shipping_progress = 1.0 * subtotal / freeShippingAmount;
        var free_shipping_progress = Math.min(1, Math.max(0, Number(free_shipping_progress)));
        var free_shipping_difference = freeShippingAmount - subtotal;
        var free_shipping_difference = Math.max(0, Number(free_shipping_difference));
        var free_shipping_difference = theme.Currency.formatMoney(free_shipping_difference, theme.settings.moneyFormat);
        var cart_drawer = document.getElementById('CartDrawer'); // .is-empty
        var freeShippingNotMetText = `Du er ${free_shipping_difference} fra gratis fragt`; // .free-shipping-bar__message--no
        // var freeShippingMetText = "Du har opnået gratis fragt!"; // .free-shipping-bar__message--yes

        if (cart_drawer.classList.contains('is-empty')) {
            freeShippingBar.classList.add('free-shipping-bar--no-cart');
        } else {
            freeShippingBar.classList.remove('free-shipping-bar--no-cart');
        }

        // data-free-shipping-progress
        document.querySelectorAll('.free-shipping-bar')[0].style.setProperty('--free-shipping-progress', free_shipping_progress);
        document.querySelectorAll('.free-shipping-bar')[0].dataset.freeShippingProgress = free_shipping_progress;

        if (free_shipping_progress < 1) {
            document.querySelectorAll('.free-shipping-bar__message--no')[0].innerText = freeShippingNotMetText;
            document.querySelectorAll('.free-shipping-bar')[0].style.setProperty('--free-shipping-bar-color', '#F9CE8F'); // progress
        } else {
            document.querySelectorAll('.free-shipping-bar')[0].style.setProperty('--free-shipping-bar-color', '#F9CE8F'); // success
        }
    }

});




"use strict";

 // * A simple snow maker using canvas by Regis Gaughan, III.
 // * The `SnowMaker` will instatiate with a `canvas` field to attach to the dom
 // * and public methods to start, stop, and pause the animation.
// The snow maker.
class SnowMaker {
    constructor(numOfFlakes = randomInt(80, 120)) {
        this.canvas = document.createElement('canvas');
        this.ctx = this.canvas.getContext('2d');
        this.flakes = [];
        this.angle = Math.random();
        this.animFrameId = 0;
        this.initCanvas();
        this.generateFlakes(numOfFlakes);
        this.attachEvents();
    }
    // Start the animation.
    start() {
        if (!this.animFrameId) {
            this.setCanvasSize();
            this.requestDraw();
        }
    }
    // Pause the animation.
    pause() {
        if (this.animFrameId) {
            window.cancelAnimationFrame(this.animFrameId);
            this.animFrameId = null;
        }
    }
    // Stop the animation (pause + clear).
    stop() {
        this.pause();
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    // Initialize the canvas & its styles.
    initCanvas() {
        this.canvas.className = 'snow';
        this.canvas.style.position = 'fixed';
        this.canvas.style.top = '0';
        this.canvas.style.left = '0';
        this.canvas.style.width = '100%';
        this.canvas.style.height = '100%';
        this.canvas.style.pointerEvents = 'none';
        this.canvas.style.zIndex = '99';
        this.setCanvasSize();
    }
    // Set the canvase size.
    setCanvasSize() {
        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;
    }
    // Attach any events we're interested in.
    attachEvents() {
        window.addEventListener('resize', () => { this.setCanvasSize(); });
    }
    // Generate our flakes.
    generateFlakes(numOfFlakes) {
        this.flakes.length = 0;
        for (var i = 0; i < numOfFlakes; i++) {
            this.flakes.push({
                x: randomInt(0, this.canvas.width),
                y: randomInt(0, this.canvas.height),
                radius: random(.25, 6),
                sway: random(-.3, .3),
                drop: random(-.5, .5),
            });
        }
    }
    // Request a draw on the next animation frame.
    requestDraw() {
        this.animFrameId = window.requestAnimationFrame(() => { this.draw(); });
    }
    // The meat, drawing our snowflakes on each frame.
    draw() {
        // Increment our angle. We use trigonometry to gently sway
        // our snowflakes back and forth
        this.angle = this.angle + 0.002;
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.fillStyle = 'rgba(255, 255, 255, .75)';
        this.ctx.beginPath();
        this.flakes.forEach((flake) => {
            // Draw our flake at its current x/y
            this.ctx.moveTo(flake.x, flake.y);
            this.ctx.arc(flake.x, flake.y, flake.radius, 0, Math.PI * 2);
            // Update our flake's next x/y.
            flake.y += 1 + flake.drop;
            flake.x += (Math.sin(this.angle) * 2) + flake.sway;
            if (flake.x > this.canvas.width + (flake.radius * 2)) {
                flake.x = randomInt(-25, (flake.radius * -2));
            }
            else if (flake.x < flake.radius * -2) {
                flake.x = this.canvas.width + randomInt(flake.radius * 2, 25);
            }
            else if (flake.y > this.canvas.height) {
                flake.x = randomInt(0, this.canvas.width);
                flake.y = flake.radius * -2;
            }
        });
        this.ctx.fill();
        this.requestDraw();
    }
}
// Helper function returning a random decimal between min and max.
function random(min, max) {
    return Math.random() * (max - min) + min;
}
// Helper functions to generate a random int inclusive of min and max.
function randomInt(min, max) {
    return (Math.floor(Math.random() * (max - min + 1)) + min);
}
// Instantiate, append its canvas, and start it up.
// const snowMaker = new SnowMaker();
// document.body.appendChild(snowMaker.canvas);
// snowMaker.start();

